/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SavedQuery } from '../models/SavedQuery';

export class ListSavedQueriesResponse {
  /**
  * List of saved queries
  */
  'savedQueries': Array<SavedQuery>;
  /**
  * Token to retrieve the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of saved queries matching the filter
  */
  'totalCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "savedQueries",
      "baseName": "savedQueries",
      "type": "Array<SavedQuery>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSavedQueriesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

